import compliance from 'data/compliance.json'
import { itemsAwaitingConfirmation } from 'utils/compliance'

/**
 * Development-only reminder listing the compliance values that the business
 * owner still has to confirm. It is never rendered in a production build, so
 * students never see it, but it keeps the outstanding items visible to anyone
 * working on the site before release.
 */
function ReviewNotice() {
  if (process.env.NODE_ENV === 'production' || !compliance.meta.pendingBusinessConfirmation) {
    return null
  }

  const pending = itemsAwaitingConfirmation()

  if (!pending.length) {
    return null
  }

  return (
    <div className='alert alert-warning mb-5' role='status'>
      <strong className='d-block mb-2'>
        Not shown in production: {pending.length} compliance values still need business confirmation
      </strong>
      <ul className='mb-0 ps-3 fs-6'>
        {pending.map((item, index) => (
          <li key={index}>
            <code>{item.path}</code>
            {item.note ? ` — ${item.note}` : ''}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ReviewNotice
